// extracted by mini-css-extract-plugin
export default {"counter":"kfq7rZ73","desktop":"desktop","mobile":"mobile"};